"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiHandler = _interopRequireDefault(require("./ApiHandler"));
var _constants = _interopRequireDefault(require("./constants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let {
  URLs,
  INDEXED_KEYS
} = _constants.default;
class WidgetHandler extends _ApiHandler.default {
  constructor() {
    super(...arguments);
    _defineProperty(this, "baseUrl", URLs.WIDGETS);
    _defineProperty(this, "fetchAccountYearlyTrend", ac => {
      return new Promise((resolve, reject) => {
        //this.nav.showOverlay();
        this.getInstance().get(this.baseUrl + '/agg/yearly/' + ac).then(response => {
          resolve(response.data);
        }).catch(() => {
          this.handleError("Error while fetching account yearly trend.");
        });
        //.finally(()=>this.nav.hideOverlay())
      });
    });
    _defineProperty(this, "fetchAccountTranTypeSplits", ac => {
      return new Promise((resolve, reject) => {
        //this.nav.showOverlay();
        this.getInstance().get(this.baseUrl + '/stats/trantype/' + ac).then(response => {
          resolve(response.data);
        }).catch(() => {
          this.handleError("Error while fetching account trantype splits.");
        });
        //.finally(()=>this.nav.hideOverlay())
      });
    });
  }
  getUserCounts() {
    return new Promise((resolve, reject) => {
      this.getInstance().get(this.baseUrl + '/agg/counts/user').then(response => {
        resolve(response.data);
      }).catch(this.handleError);
    });
  }
  getAccountYearlyTrend() {
    let unset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let ac = this.getActiveAccount();
    if (!ac) {
      //this.showWarn('Please select an account to fetch yearly trend.');
      return;
    }
    return this.cachedResponse(unset, INDEXED_KEYS.ACCOUNT_YEARLY_TREND + '_' + ac, this.fetchAccountYearlyTrend, [ac]);
  }
  getAccountTranTypeSplits() {
    let unset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let ac = this.getActiveAccount();
    if (!ac) {
      //this.showWarn('Please select an account to fetch tran type splits.');
      return;
    }
    return this.cachedResponse(unset, INDEXED_KEYS.ACCOUNT_TRANTYPE_SPLITS + '_' + ac, this.fetchAccountTranTypeSplits, [ac]);
  }
}
exports.default = WidgetHandler;